import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getRefundReleaseUserInput,
  getRefundReleaseUsersInput,
  RefundReleaseUserLiteModel,
  RefundReleaseUserModel,
} from './model';

export function useGetRefundReleaseUsers(
  input?: getRefundReleaseUsersInput,
  options?: UseQueryOptions<
    ExtendedApiResult<RefundReleaseUserLiteModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<RefundReleaseUserLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['release-sales', input?.params],
      () =>
        QueryFetchFunction({
          url: 'release-sales',
          params: input?.params,
        }),
      options,
    ),
    RefundReleaseUserLiteModel,
  );
}

export function useGetRefundReleaseUser(
  input?: getRefundReleaseUserInput,
  options?: UseQueryOptions<ApiResult<RefundReleaseUserModel>, ApiError>,
): UseQueryResult<ApiResult<RefundReleaseUserModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['release-sale', input?.id],
      () =>
        QueryFetchFunction({
          url: `release-sales/${input?.id}`,
        }),
      options,
    ),
    RefundReleaseUserModel,
  );
}

export function getRefundReleaseUsersKey(input?: getRefundReleaseUsersInput) {
  return ['release-sales', input?.params];
}

export function getRefundReleaseUserKey(input?: getRefundReleaseUserInput) {
  return ['release-sale', input?.id];
}
